import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0001 6.16669C13.0001 5.6144 12.5524 5.16669 12.0001 5.16669C11.4478 5.16669 11.0001 5.6144 11.0001 6.16669V11H6.16675C5.61446 11 5.16675 11.4477 5.16675 12C5.16675 12.5523 5.61446 13 6.16675 13H11.0001V17.8334C11.0001 18.3856 11.4478 18.8334 12.0001 18.8334C12.5524 18.8334 13.0001 18.3856 13.0001 17.8334V13H17.8334C18.3857 13 18.8334 12.5523 18.8334 12C18.8334 11.4477 18.3857 11 17.8334 11H13.0001V6.16669Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
